import Axios from 'axios';
import { csvParse as d3CsvParse } from 'd3-dsv';

const SET_DEFAULTS = 'App/AppState/SET_DEFAULTS';
const LOAD_START = 'App/AppState/LOAD_START';
const LOAD_SUCCESS = 'App/AppState/LOAD_SUCCESS';
const LOAD_ERROR = 'App/AppState/LOAD_ERROR';

const SET_BUDGET = 'App/AppState/SET_BUDGET';
const SET_SELECTED_COUNTRY = 'App/AppState/SET_SELECTED_COUNTRY';
const SET_INFOBOX_MODE = 'App/AppState/SET_INFOBOX_MODE';

const initialState = {
  loading: true,
  chartData: false,
  countries: false,
  referenceCountry: 'DE',
  selectedCountry: 'EU',
  budget: null,
  infoboxMode: '',
  showIncomeSection: false
};

export function setDefaultsFromLang(config) {
  return { type: SET_DEFAULTS, config };
}

function getCountryData() {
  return Axios.get('data/data_2019.csv');
}

function getCountryList() {
  return Axios.get('data/Laender.csv');
}

export function loadData(language) {
  return (dispatch) => {
    dispatch({ type: LOAD_START });

    Axios.all([getCountryData(), getCountryList()])
      .then(Axios.spread((countryData, countryList) => {
        const countries = d3CsvParse(countryList.data) || [];
        const chartData = d3CsvParse(countryData.data)
          .map((entry) => {
            const propertyKeys = [
              'Country_Code',
              'Median',
              'Mittelwert',
              'Einkommensarme_Schicht',
              'Einkommensschwache_Mitte',
              'Mitte_im_engen_Sinn',
              'Einkommensstarke_Mitte',
              'Einkommensreiche_Schicht',
              'Einkommensarme_Schicht_boundry',
              'Einkommensschwache_Mitte_boundry',
              'Mitte_im_engen_Sinn_boundry',
              'Einkommensstarke_Mitte_boundry',
              'Einkommensreiche_Schicht_boundry'
            ];
            const keys = Object.keys(entry);

            const values = keys.reduce((res, key) => {
              // filter propertyKeys
              if (propertyKeys.indexOf(key) === -1) {
                res.push(({ key, value: +entry[key] }));
              }
              return res;
            }, []);

            return ({
              country_code: entry.Country_Code,
              median: entry.Median,
              mittelwert: entry.Mittelwert,
              incomeLayer: [
                { key: 'einkommensarme_Schicht', value: entry.Einkommensarme_Schicht, min: 0, max: entry.Einkommensarme_Schicht_boundry },
                { key: 'einkommensschwache_Mitte', value: entry.Einkommensschwache_Mitte, min: entry.Einkommensarme_Schicht_boundry, max: entry.Einkommensschwache_Mitte_boundry },
                { key: 'mitte_im_engen_Sinn', value: entry.Mitte_im_engen_Sinn, min: entry.Einkommensschwache_Mitte_boundry, max: entry.Mitte_im_engen_Sinn_boundry },
                { key: 'einkommensstarke_Mitte', value: entry.Einkommensstarke_Mitte, min: entry.Mitte_im_engen_Sinn_boundry, max: entry.Einkommensstarke_Mitte_boundry },
                { key: 'einkommensreiche_Schicht', value: entry.Einkommensreiche_Schicht, min: entry.Einkommensstarke_Mitte_boundry, max: 6201 }
              ],
              values
            });
          });

        const sortBy = language === 'de' ? 'Country_Label_de' : 'Country_Label_en';
        const countriesSorted = countries.sort((a, b) => a[sortBy].localeCompare(b[sortBy]));

        dispatch({ type: LOAD_SUCCESS, countries: countriesSorted, chartData });
      }))
      .catch((error) => {
        console.log(error);
        dispatch({ type: LOAD_ERROR });
      });
  };
}

export function setBudget(budget) {
  return { type: SET_BUDGET, budget };
}

export function setSelectedCountry(countryCode) {
  return { type: SET_SELECTED_COUNTRY, countryCode };
}

export function setInfoboxMode(infoboxMode) {
  return { type: SET_INFOBOX_MODE, infoboxMode };
}

export default function AppReducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_START:
      return Object.assign({}, state, { loading: true });

    case LOAD_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        countries: action.countries,
        chartData: action.chartData
      });

    case SET_BUDGET:
      return Object.assign({}, state, {
        budget: action.budget
      });

    case SET_SELECTED_COUNTRY:
      return Object.assign({}, state, {
        selectedCountry: action.countryCode
      });

    case SET_INFOBOX_MODE:
      return Object.assign({}, state, action);

    case SET_DEFAULTS:
      return Object.assign({}, state, {
        referenceCountry: action.config.referenceCountry,
        selectedCountry: action.config.selectedCountry,
        showIncomeSection: action.config.showIncomeSection,
        formulaFactor: action.config.formulaFactor
      });

    default:
      return Object.assign({}, state);
  }
}



// WEBPACK FOOTER //
// ./src/modules/App/AppState.js